import SchoolListSection from "./components/school-list-section";

function SchoolManagement() {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Schools List - Takes remaining height */}
      <div className="h-full">
        <SchoolListSection />
      </div>
    </div>
  );
}

export default SchoolManagement;
